import { render, staticRenderFns } from "./WithdrawBalanceSucc.vue?vue&type=template&id=26bcdfaa&scoped=true"
import script from "./WithdrawBalanceSucc.vue?vue&type=script&lang=js"
export * from "./WithdrawBalanceSucc.vue?vue&type=script&lang=js"
import style0 from "./WithdrawBalanceSucc.vue?vue&type=style&index=0&id=26bcdfaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bcdfaa",
  null
  
)

export default component.exports